import NotificationActionCreators from './NotificationActionCreators'
import { NotificationScopes } from '../AppConstants'

export const handleUploadAttempted = (): void => {
  NotificationActionCreators.removeAllNotificationsByScope(
    NotificationScopes.FILE_UPLOAD,
  )
}
